import React, { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <style jsx>{`
        .header {
          background: linear-gradient(135deg, #1e88e5 0%, #1976d2 100%);
          padding: 12px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: sticky;
          top: 0;
          z-index: 1000;
          overflow: visible;
          box-shadow: 0 4px 20px rgba(30, 136, 229, 0.3);
          min-height: 70px;
        }

        .header::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, transparent 50%);
          animation: shimmer 3s ease-in-out infinite;
        }

        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }

        .left-section {
          display: flex;
          align-items: center;
          gap: 20px;
          flex: 1;
          z-index: 2;
        }

        .logo-section {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .faucon-logo {
          display: flex;
          height: 80px;
          align-items: center;
          gap: 8px;
          animation: fadeInLeft 0.8s ease-out;
        }

        .faucon-logo img {
          height: 100%;
          width: auto;
          object-fit: contain;
        }

        .logo-placeholder {
          width: 40px;
          height: 40px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          transition: all 0.3s ease;
        }

        .logo-placeholder:hover {
          transform: scale(1.1) rotate(10deg);
          background: rgba(255, 255, 255, 0.3);
        }

        .brand-text {
          color: white;
          font-family: 'Arial', sans-serif;
          margin: 0;
        }

        .brand-name {
          font-size: 24px;
          font-weight: bold;
          letter-spacing: 1px;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }

        .brand-subtitle {
          font-size: 11px;
          opacity: 0.9;
          margin-top: -2px;
          font-weight: normal;
          letter-spacing: 0.5px;
        }

        .divider {
          width: 2px;
          height: 50px;
          background: rgba(255, 255, 255, 0.4);
          margin: 0 15px;
          animation: slideDown 0.6s ease-out 0.3s both;
        }

        .partner-section {
          display: flex;
          align-items: center;
          gap: 12px;
          animation: fadeInUp 0.8s ease-out 0.4s both;
        }

        .shell-logo {
          width: 45px;
          height: 45px;
          background: #FFD700;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #FF0000;
          font-weight: bold;
          font-size: 12px;
          box-shadow: 0 4px 15px rgba(255, 215, 0, 0.4);
          transition: all 0.3s ease;
          animation: pulse 2s ease-in-out infinite;
          overflow: hidden;
        }

        .shell-logo img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .shell-logo:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 25px rgba(255, 215, 0, 0.6);
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        .partner-text {
          color: white;
          font-family: 'Arial', sans-serif;
          font-weight: bold;
          font-size: 16px;
          text-shadow: 1px 1px 3px rgba(0,0,0,0.3);
          line-height: 1.2;
        }

        .buttons-section {
          display: flex;
          gap: 15px;
          z-index: 2;
          animation: fadeInRight 0.8s ease-out 0.6s both;
        }

        .header-btn {
          background: rgba(255, 255, 255, 0.9);
          color: #1976d2;
          border: none;
          padding: 12px 24px;
          border-radius: 25px;
          font-weight: bold;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
          box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);
          letter-spacing: 0.5px;
          text-decoration: none;
          display: inline-block;
        }

        .header-btn:hover {
          background: white;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(255, 255, 255, 0.3);
        }

        .header-btn:active {
          transform: translateY(0);
        }

        .mobile-menu-toggle {
          display: none;
          background: rgba(255, 255, 255, 0.9);
          border: none;
          padding: 8px;
          border-radius: 8px;
          cursor: pointer;
          z-index: 3;
        }

        .mobile-menu-toggle span {
          display: block;
          width: 25px;
          height: 3px;
          background: #1976d2;
          margin: 5px 0;
          transition: 0.3s;
          border-radius: 2px;
        }

        .mobile-menu-toggle.active span:nth-child(1) {
          transform: rotate(-45deg) translate(-5px, 6px);
        }

        .mobile-menu-toggle.active span:nth-child(2) {
          opacity: 0;
        }

        .mobile-menu-toggle.active span:nth-child(3) {
          transform: rotate(45deg) translate(-5px, -6px);
        }

        .mobile-menu {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: linear-gradient(135deg, #1e88e5 0%, #1976d2 100%);
          padding: 20px;
          transform: translateY(-100%);
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          z-index: 999;
          box-shadow: 0 4px 20px rgba(30, 136, 229, 0.3);
          border-radius: 0 0 15px 15px;
        }

        .mobile-menu.active {
          transform: translateY(0);
          opacity: 1;
          visibility: visible;
        }

        .mobile-buttons {
          display: flex;
          flex-direction: column;
          gap: 15px;
          align-items: center;
        }

        .mobile-partner {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 15px;
          margin-bottom: 20px;
          padding: 15px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 15px;
        }

        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: scaleY(0);
          }
          to {
            opacity: 1;
            transform: scaleY(1);
          }
        }

        @media (max-width: 768px) {
          .header {
            padding: 10px 16px;
          }

          .left-section {
            gap: 10px;
          }

          .faucon-logo {
            height: 60px;
          }

          .partner-section {
            display: none;
          }

          .divider {
            display: none;
          }

          .buttons-section {
            display: none;
          }

          .mobile-menu-toggle {
            display: block;
          }

          .brand-name {
            font-size: 18px;
          }

          .brand-subtitle {
            font-size: 9px;
          }
        }

        @media (max-width: 480px) {
          .header {
            padding: 8px 12px;
          }

          .faucon-logo {
            height: 50px;
          }

          .brand-name {
            font-size: 16px;
          }

          .logo-section {
            gap: 8px;
          }

          .mobile-menu {
            padding: 15px;
          }

          .header-btn {
            width: 100%;
            text-align: center;
            padding: 15px 20px;
            font-size: 16px;
          }
        }

        /* SEO and Accessibility improvements */
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }

        .header-btn:focus,
        .mobile-menu-toggle:focus {
          outline: 3px solid rgba(255, 255, 255, 0.8);
          outline-offset: 2px;
        }
      `}</style>

      <header className="header" role="banner">
        <div className="left-section">
          <div className="logo-section">
            <div className="faucon-logo">
              <img 
                src='/images/logo-header.png' 
                alt="Faucon Bleu - Service automobile mobile à Casablanca"
                loading="eager"
                width="200"
                height="80"
              />
            </div>

            <div className="divider" aria-hidden="true"></div>

            <div className="partner-section">
              <div className="shell-logo">
                <img 
                  src='/images/shell.png' 
                  alt="Shell - Partenaire officiel"
                  loading="lazy"
                  width="45"
                  height="45"
                />
              </div>
              <div className="partner-text">
                PARTENAIRE<br />
                OFFICIEL
              </div>
            </div>
          </div>
        </div>

        <nav className="buttons-section" role="navigation" aria-label="Navigation principale">
          <a href="#particulier" className="header-btn" role="button" aria-label="Services pour particuliers">
            PARTICULIER
          </a>
          <a href="#entreprise" className="header-btn" role="button" aria-label="Services pour entreprises">
            ENTREPRISE
          </a>
        </nav>

        <button 
          className={`mobile-menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
          aria-expanded={isMenuOpen}
          aria-controls="mobile-menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div 
          id="mobile-menu"
          className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}
          role="navigation"
          aria-label="Menu mobile"
        >
          <div className="mobile-partner">
            <div className="shell-logo">
              <img 
                src='/images/shell.png' 
                alt="Shell - Partenaire officiel"
                loading="lazy"
                width="45"
                height="45"
              />
            </div>
            <div className="partner-text">
              PARTENAIRE<br />
              OFFICIEL
            </div>
          </div>
          
          <div className="mobile-buttons">
            <a 
              href="#particulier" 
              className="header-btn" 
              onClick={() => setIsMenuOpen(false)}
              aria-label="Services pour particuliers"
            >
              PARTICULIER
            </a>
            <a 
              href="#entreprise" 
              className="header-btn" 
              onClick={() => setIsMenuOpen(false)}
              aria-label="Services pour entreprises"
            >
              ENTREPRISE
            </a>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;